export default "__VITE_ASSET__2c7bd000__"